<div class="tw-relative tw-overflow-hidden">
  <button
    type="button"
    mat-icon-button
    class="ai-credits-modal-close tw-absolute tw-top-2 tw-right-2 lg:!tw-top-4 lg:!tw-right-4 tw-w-10 tw-h-10 lg:!tw-w-14 lg:!tw-h-14 tw-z-[2] tw-p-0 tw-bg-black/10 tw-rounded-lg"
    (click)="close()"
    aria-label="Close"
  >
    <mat-icon svgIcon="close" class="medium"></mat-icon>
  </button>

  <div class="tw-flex tw-flex-col lg:!tw-flex-row">
    <!-- Art image — top on mobile, right side on desktop -->
    <div
      class="tw-hidden lg:!tw-h-auto lg:!tw-w-1/2 tw-flex-none lg:!tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden"
    >
      <img
        src="/images/generate-with-ai.gif"
        alt="AI Credits illustration"
        class="tw-w-full tw-h-auto tw-object-fill tw-relative tw-z-[1]"
      />
    </div>

    <!-- Text content -->
    <div
      class="lg:!tw-w-1/2 tw-py-12 tw-px-12 md:!tw-py-[100px] md:!tw-px-[52px] tw-flex tw-flex-col tw-justify-center lg:!tw-order-first"
    >
      <rv-badge
        class="tw-mb-[24px]"
        color="blue"
        icon="requires-upgrade"
        text="Unlock more AI Credits"
      />

      <h2
        class="ai-credits-modal-title tw-text-[24px] tw-font-bold tw-m-0 tw-mb-[24px] tw-leading-none"
      >
        Want More AI Credits?
      </h2>

      <p
        class="ai-credits-modal-body tw-text-[14px] tw-leading-relaxed tw-m-0 tw-mb-0"
      >
        AI-generated presentations use credits. Every plan includes a set
        amount, with higher tiers offering more. Need extra? You can purchase
        additional credits anytime.
      </p>

      @if (data.hasPlan && !data.canModifyPlan) {
        <p class="tw-text-green-700 tw-font-medium tw-mt-[8px]">
          Contact your parent company admin to increase the credit cap or
          upgrade your company plan.
        </p>
      }

      <div
        class="tw-flex tw-flex-col sm:!tw-flex-row tw-items-stretch tw-mt-[24px] sm:!tw-items-center tw-gap-3"
      >
        @if (!data.hasPlan) {
          <button
            mat-flat-button
            color="primary"
            class="!tw-rounded-lg tw-h-16 tw-font-medium tw-text-[14px] sm:!tw-min-w-[180px]"
            (click)="seePlans()"
          >
            See Plans
          </button>
        } @else if (data.canModifyPlan) {
          <button
            mat-flat-button
            color="primary"
            class="!tw-rounded-lg tw-h-16 tw-font-medium tw-text-[14px] sm:!tw-min-w-[180px]"
            (click)="purchaseCredits()"
          >
            Get More Credits
          </button>
        } @else {
          <button
            mat-flat-button
            color="primary"
            class="!tw-rounded-lg tw-h-16 tw-font-medium tw-text-[14px] sm:!tw-min-w-[180px]"
            [mat-dialog-close]="false"
          >
            Okay, Got It!
          </button>
        }
      </div>
    </div>
  </div>
</div>
